import { render, staticRenderFns } from "./AppPanels.vue?vue&type=template&id=f935c5a8&scoped=true"
import script from "./AppPanels.vue?vue&type=script&lang=js"
export * from "./AppPanels.vue?vue&type=script&lang=js"
import style0 from "./AppPanels.vue?vue&type=style&index=0&id=f935c5a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f935c5a8",
  null
  
)

export default component.exports